import {Injectable, OnDestroy} from '@angular/core';
import {RedirectUrlService} from '@app/_services/redirect-url.service';
import {SessionService} from '@irisims/justconsult-api';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class KeepAliveService implements OnDestroy {

  private timeOut: ReturnType<typeof setInterval>;
  worker: Worker;
  

  constructor(private redirectUrlService: RedirectUrlService,
              private sessionService: SessionService) {
                if (typeof Worker !== 'undefined') {
                  this.worker = new Worker(new URL('../keep-alive.worker', import.meta.url));
                  this.worker.onmessage = ({ data }) => {
                    this.sessionService.keepAlive().pipe(first()).subscribe();
                  };
                }
              }

  ngOnDestroy(): void {
    this.worker.terminate();
  }

  innitKeepAliveTimer(): void {
    let delay  = (this.redirectUrlService.configObject$.value?.refreshTokenValidy * 60 * 1000);
    delay = delay -(delay * 0.2);
    this.worker.postMessage({delay: delay});
  }

  clearKeepAliveTimer(): void {
      this.worker.postMessage({stop: true});
  }
}
